




























import {
  Component,
  Vue,
  Prop
} from "@/shared/vuepack";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap,
  HsabExpenseCategory,
  HsabExpenseResponse,
  hsabExpenseCategoryMap,
  hsabExpenseOriginatorTypeMap,
} from "@/shared/types";
import moment from "moment";
import _ from "lodash";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { formatCurrency } from "@/shared/currency.js";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { ExpenseManagementGoLiveDate } from  "@/employee/Utilities/HsabExpenseUtility";
import { useFamilyStore } from "@/employer/store/family";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill
  }
})
export default class AccountHolderExpenseDetail extends Vue {
  formatCurrency = formatCurrency;
  familyStore = useFamilyStore();
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;
  hsabExpenseCategoryMap = hsabExpenseCategoryMap;

  mounted () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.familyStore.initialize(args);
  }
  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  @Prop()
  expense: HsabExpenseResponse;

  get formattedDateOfService () {
    return moment(this.expense.dateOfService).format("MMM DD, YYYY");
  }

  get formattedSubmittedDate () {
    return moment(this.expense.reimbursement.dateCreated).format("MMM DD, YYYY");
  }

  get formattedOriginator () {
    if (this.expense.originator) {
      return this.hsabExpenseOriginatorTypeMap[this.expense.originator];
    }
    return "Unknown";
  }

  get formattedCategory () {
    if (this.expense.expenseCategory) {
      return this.hsabExpenseCategoryMap[this.expense.expenseCategory];
    }
    return "Unknown";
  }

  get status (): CombinedClaimReceiptStatus {
    return this.expense.reimbursement ?
        this.expense.reimbursement.claimReceiptStatus :
        CombinedClaimReceiptStatus.None;
  }

  get statusDisplayText () {
    return CombinedClaimReceiptStatusMap[this.status];
  }

  get showCategory () {
    return this.expense
        && this.expense.expenseCategory !== undefined
        && this.expense.expenseCategory !== null
        && this.expense.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showExpenseType () {
    return this.expense
        && this.expense.expenseType !== undefined
        && this.expense.expenseType !== null
        && this.expense.expenseType !== "";
  }

  get showExpenseSubType () {
    return !isNullEmptyOrUndefined(this.SubTypeDisplay);
  }

  get showAmount () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.amount);
  }

  get showProviderName () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.providerName);
  }

  get showSource () {
    return !isNullEmptyOrUndefined(this.formattedOriginator);
  }

  get showDateOfExpense () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.dateOfService);
  }

  get showSubmittedDate (): boolean {
    if (!isNullEmptyOrUndefined(this.expense)
    && !isNullEmptyOrUndefined(this.expense.reimbursement)
    && !isNullEmptyOrUndefined(this.expense.reimbursement.dateCreated)) {
      const  dateCreated = moment(this.expense.reimbursement.dateCreated);
      const  dateCutoff = moment(ExpenseManagementGoLiveDate);
      return dateCreated > dateCutoff;
    }
    return false;
  }

  get showStatus () {
    return !isNullEmptyOrUndefined(this.statusDisplayText);
  }

  get showRecipient () {
    return this.expense
      && (this.expense.recipientExternalId || (this.expense.importedRecipients && this.expense.importedRecipients.length > 0));
  }

  get recipientDisplay (): string {
    if (this.expense.recipientExternalId && this.familyStore.familyMembers) {
      const foundFamilyMember = _.find(this.familyStore.familyMembers, f => f.externalId === this.expense.recipientExternalId);
      if (foundFamilyMember) {
        return `${foundFamilyMember.firstName} ${this.middleInitial(foundFamilyMember.middleInitial)} ${foundFamilyMember.lastName}`;
      }
    }
    if (this.expense && this.expense.importedRecipients && this.expense.importedRecipients.length > 0) {
      return this.expense.importedRecipients.map(t => {
        return `${t.firstName} ${this.middleInitial(t.middleInitial)} ${t.lastName}`;
      }).join("\n");
    }
    return "";
  }
  middleInitial (middleInitial: string) {
    if (middleInitial) {
      return middleInitial;
    }
    return "";
  }
  get showEobOrClaimNumber () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.externalReferenceId);
  }

  get showMilesTraveled () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.numberOfMiles);
  }

  get showMileageReimbursementAmount () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.mileageDollarValue);
  }

  get showComment () {
    return !isNullEmptyOrUndefined(this.expense)
        && !isNullEmptyOrUndefined(this.expense.comment);
  }

  get SubTypeDisplay () {
    if (this.expense
        && !isNullEmptyOrUndefined(this.expense.expenseSubTypeDisplayName)) {
      return this.expense.expenseSubTypeDisplayName;
    }
    if (this.expense
        && !isNullEmptyOrUndefined(this.expense.expenseSubType)) {
      return this.expense.expenseSubType;
    }

    return "";
  }
}
